import { makeStyles } from "@material-ui/core/styles";
import {
  messagesBackground,
  black,
  tooltipShadow,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: messagesBackground,
    color: black,
    boxShadow: tooltipShadow,
    fontSize: 13,
    fontWeight: "normal",
    padding: theme.spacing(2),
    textShadow: "none",
  },
}));

export default useStyles;
